// Règles de visibilité et d'activation du menu latéral — fonctions pures,
// reprises de l'ancienne Sidenav pour rester iso-fonctionnel :
// - un partenaire (MANAGER_PARTNER / AGENT_PARTNER) sans `isEP` ne voit pas
//   les entrées `isEP` ;
// - une entrée `directorOnly` n'est visible que du Directeur de la Caf ou de
//   ses délégataires (`isDirector`) ;
// - une entrée `dataPriv` est masquée si roleConfig[role] liste ce privilège
//   (même règle que RoleStyle, qui masque aussi en CSS via [data-priv]).

import { estUtilisateurOperateur } from "../../../../helpers/rolesManager";
import { MENU_OPERATEUR } from "../../../../sidenavItems";

export const ROLES_PARTENAIRES = ["MANAGER_PARTNER", "AGENT_PARTNER"];

export const estGroupe = (item) => Boolean(item) && item.path === "#" && Array.isArray(item.items);

export function privilegesMasques(user, roleConfig) {
  return (user && roleConfig && roleConfig[user.role]) || [];
}

export function estMasque(item, user = {}, privileges = []) {
  const partenaireSansEP = ROLES_PARTENAIRES.includes(user.role) && !user.isEP;
  const directeurOuDelegataire = user.role === "CAF_DIRECTOR" || user.isDirector === true;
  return Boolean(
    (item.isEP && partenaireSansEP) ||
      (item.directorOnly && !directeurOuDelegataire) ||
      (item.dataPriv && privileges.includes(item.dataPriv))
  );
}

export function aEnfantVisible(groupe, user, privileges) {
  return estGroupe(groupe) && groupe.items.some((it) => !estMasque(it, user, privileges));
}

// Arbre visible pour un utilisateur : entrées masquées retirées, groupes
// réduits à leurs enfants visibles, groupes vides retirés. L'ordre est conservé.
// Un compte d'opérateur (CE-1407) reçoit son propre menu, réduit à sa
// structure, quel que soit le menu Caf passé.
export function filtrerMenu(items, user, privileges) {
  if (estUtilisateurOperateur(user)) return MENU_OPERATEUR.map((item) => ({ ...item }));
  return (items || []).reduce((visibles, item) => {
    if (estGroupe(item)) {
      const enfants = item.items.filter((it) => !estMasque(it, user, privileges));
      if (enfants.length) visibles.push({ ...item, items: enfants });
    } else if (!estMasque(item, user, privileges)) {
      visibles.push(item);
    }
    return visibles;
  }, []);
}

// Une route est active sur elle-même et sur ses sous-routes (`/recipients/12`),
// jamais sur une route voisine partageant le préfixe (`/recipients-temp`).
export function estRouteActive(path, pathname) {
  if (!path || path === "#" || !pathname) return false;
  if (path === "/") return pathname === "/";
  return pathname === path || pathname.startsWith(path + "/");
}

export function contientRoute(groupe, pathname) {
  return estGroupe(groupe) && groupe.items.some((it) => estRouteActive(it.path, pathname));
}

// Nom du groupe contenant la route courante (null hors groupe).
export function groupeDeLaRoute(items, pathname) {
  const groupe = (items || []).find((item) => contientRoute(item, pathname));
  return groupe ? groupe.name : null;
}

// Entrée (ou sous-entrée) dont la route est active — sert de titre à la barre
// haute sur mobile et désigne la seule entrée marquée courante dans le menu.
// Quand deux entrées couvrent la route (`/operateurs` et
// `/operateurs/accompagnement`), la plus précise l'emporte.
export function entreeActive(items, pathname) {
  let retenue = null;
  const retenir = (it) => {
    if (estRouteActive(it.path, pathname) && (!retenue || it.path.length > retenue.path.length)) {
      retenue = it;
    }
  };
  for (const item of items || []) {
    if (estGroupe(item)) item.items.forEach(retenir);
    else retenir(item);
  }
  return retenue;
}
